module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/89606977495eb20404fcfad6f6a58df3.gif";